import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  description?: string;
  actionText?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionText,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-fire-line" />
            {eyebrow}
          </span>
        )}
        <h2 className="mt-3 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            {description}
          </p>
        )}
      </div>
      {actionText && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-primary-200 bg-background-50 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
        >
          {actionText}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}